module.exports = __webpack_public_path__ + "img/collection-weddingRingsGayLesbianCouples.a456da3.webp";